import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  useRecordContext,
  Link,
  Edit,
  Create,
  TextInput,
  BooleanInput,
  required,
  SimpleForm,
  Show,
  SimpleShowLayout,
  BooleanField,
  FunctionField
} from "react-admin";
import { Card, CardContent } from "@mui/material";
import CustomDateField, { deletedRowStyle, UserLinkField } from "./users";
import { Avatar, Typography, Box } from "@mui/material";
import { useParams } from 'react-router-dom';

const DomainTitle = () => {
  const record = useRecordContext();
  return record ? (
    <span>
      {record.domain} ({record._id})
    </span>
  ) : null;
};

const domainFilters = [
  <TextInput label="Domain ID" source="_id" alwaysOn />,
  <TextInput label="Domain" source="domain" alwaysOn />
];

export const DomainList = (props) => (
  <List {...props} filters={domainFilters}>
    <Datagrid rowClick="edit" rowStyle={deletedRowStyle}>
      <TextField source="_id" />
      <TextField source="domain" />
      <BooleanField source="can_be_captured" />
      <TextField source="number_of_users" />
    </Datagrid>
  </List>
);

export const DomainEdit = () => (
  <Edit title={<DomainTitle />}>
    <SimpleForm>
      <TextInput source="domain" fullWidth validate={required()} />
      <BooleanInput source="can_be_captured" label="Can Be Captured" />
      <TextField source="number_of_users" label="Number of Users" disabled />
    </SimpleForm>
  </Edit>
);

export const DomainCreate = () => (
  <Create title="Create Domain">
    <SimpleForm>
      <TextInput source="domain" fullWidth validate={required()} />
      <BooleanInput source="can_be_captured" label="Can Be Captured" defaultValue={true} />
    </SimpleForm>
  </Create>
);

export const DomainShow = () => (
  <Show title={<DomainTitle />}>
    <SimpleShowLayout>
      <TextField source="_id" />
      <TextField source="domain" />
      <BooleanField source="can_be_captured" />
      <TextField source="number_of_users" />
    </SimpleShowLayout>
  </Show>
); 